var render = function (_h,_vm) {var _c=_vm._c;return _c('li',{staticClass:"list-group-item",class:{ clickable: _vm.props.clickable !== undefined ? _vm.props.clickable : true }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }